import React, { useContext, useState } from 'react';
import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import { AuthContext } from './App';
import { useHistory, useLocation } from 'react-router';

export default () => {
    const auth = useContext(AuthContext);
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [loginErr, setLoginErr] = useState(null);

    return (
        <div style={{ background: '#fff', padding: 24, width: 320, boxShadow: 'rgba(0,0,0,.08) 0 0 10px', position: 'absolute', top: '50%', left: '50%', margin: '-160px 0 0 -160px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="logo" style={{ width: 170, height: 70, background: 'url("/images/logo1.png")', backgroundSize: '100% 100%', margin: 16, marginBottom: 30 }} />
            </div>
            <Antd.Form                
                onFinish={async (values) => {
                    try {
                        setLoading(true);
                        await auth.signIn(values);
                        history.replace(location.state && location.state.from || { pathname: "/" });
                    } catch (err) {
                        console.log(err);
                        setLoginErr({
                            message: "Login failed",
                            description: "Check your credentials or contact system administrator!"
                        });
                    } finally {
                        setLoading(false);
                    }
                }}
            >
                {loginErr
                    ? <Antd.Alert
                        message={loginErr.message}
                        description={loginErr.description}
                        type="error"
                        showIcon
                        style={{
                            marginBottom: 20
                        }}
                    />
                    : null}
                <Antd.Form.Item
                    name="username"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                >
                    <Antd.Input
                        prefix={<AntdIcons.UserOutlined />}
                        placeholder="Username"
                    />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                >
                    <Antd.Input
                        prefix={<AntdIcons.LockOutlined />}
                        type="password"
                        placeholder="Password"
                    />
                </Antd.Form.Item>
                <Antd.Form.Item>
                    <Antd.Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        style={{
                            width: '100%'
                        }}
                    >
                        Sign in
                    </Antd.Button>
                </Antd.Form.Item>
            </Antd.Form>
        </div>
    );
}
